import { ExpressionType } from '../../IExpression';
import { IEvaluationVariables } from '../../evaluate/variables/IEvaluationVariables';
import { IAsyncService } from './context/IAsyncService';
import { IAsyncServiceInputConfig } from './useAsyncServiceFetch';

/**
 * Costruisce i parametri/dati da passare in input al servizio asincrono
 */
export function buildAsyncServiceParams(
  service: IAsyncService,
  inputs: IAsyncServiceInputConfig,
  variables: IEvaluationVariables,
): Record<string, string | number> {
  const params = {} as any;
  service.inputs.forEach(input => {
    const expression = inputs[input.name];
    if (!expression) return;
    if (expression.type === ExpressionType.Value && expression.value) {
      params[input.name] = expression.value;
    }
    if (expression.type === ExpressionType.Reference && expression.value.id) {
      params[input.name] = variables[expression.value.id];
    }
  });

  return params;
}
